import React, { useEffect, useState } from "react";
import ToolsContentTextCheckBox from "../../../Tools/ToolsCommon/ToolsContentTextCheckBox";
import ToolsContentTextBox from "../../../Tools/ToolsCommon/ToolsContentTextBox";
import ToolsContentButton from "../../../Tools/ToolsCommon/ToolsContentButton";
import TestingApi from "../../../../api/TestingApi";
import { ETestingType } from "../../../../Model/TestingParameter";
import { useTypedSelector } from "../../../../redux/reducers/RootReducer";
import {
  getImagerTestingState,
  getSuiteMode,
} from "../../../../redux/reducers/ModuleStateReducer";
import { ETestingState, ESuiteMode } from "../../../../Model/ModuleState";

type Props = {
  imagerIdentifier: string;
};
export default function ObjectiveSwitchingTest({ imagerIdentifier }: Props) {
  const testing = useTypedSelector((state) =>
    getImagerTestingState(state, imagerIdentifier)
  );
  const suiteMode = useTypedSelector((state) => getSuiteMode(state));
  const [status, setStatus] = useState("Count : ");

  useEffect(() => {
    if (testing.objectiveSwitching?.state === ETestingState.Started) {
      const counter = testing.objectiveSwitching?.counter ?? 0;
      setStatus("Count : " + counter.toString());
    }
  }, [testing.objectiveSwitching?.counter]);

  useEffect(() => {
    if (testing.objectiveSwitching?.state === ETestingState.Started) {
      const parameter = testing.objectiveSwitching.parameter;

      setTestParameterValue({
        captureImageEvery:
          parameter?.captureImageEvery ?? testParameterValue.captureImageEvery,
        saveCapturedImageEvery:
          parameter?.saveCapturedImageEvery ??
          testParameterValue.saveCapturedImageEvery,
      });
    }
  }, [
    testing.objectiveSwitching?.parameter?.captureImageEvery,
    testing.objectiveSwitching?.parameter?.saveCapturedImageEvery,
  ]);

  const isDisabled = suiteMode !== ESuiteMode.Normal;
  const isRunningObjectiveSwitchingTest =
    suiteMode === ESuiteMode.Testing &&
    testing.objectiveSwitching?.state === ETestingState.Started;

  const [testParameterValue, setTestParameterValue] = useState({
    captureImageEvery: 2,
    saveCapturedImageEvery: 2,
  });

  const [testParameterActive, setTestParameterActive] = useState({
    captureImageEvery: true,
    saveCapturedImageEvery: true,
  });

  const runTest = () => {
    TestingApi.doTesting({
      moduleIdentifier: imagerIdentifier,
      type: ETestingType.ObjectiveSwitching,
      objectiveSwitchingTest: {
        captureImageEvery: testParameterActive.captureImageEvery
          ? testParameterValue.captureImageEvery
          : undefined,
        saveCapturedImageEvery: testParameterActive.saveCapturedImageEvery
          ? testParameterValue.saveCapturedImageEvery
          : undefined,
      },
    });
  };

  const stopTest = () => {
    TestingApi.stopTesting();
  };

  return (
    <div className={"testing-content"}>
      <ToolsContentTextCheckBox
        disabled={isDisabled}
        id="imageEvery"
        checked={testParameterActive.captureImageEvery}
        label="Image Every"
        checkBoxColorVariant={"alternate"}
        value={testParameterValue.captureImageEvery}
        onClickRadio={() =>
          setTestParameterActive({
            ...testParameterActive,
            captureImageEvery: !testParameterActive.captureImageEvery,
          })
        }
        onChangeValue={(value) => {
          setTestParameterValue({
            ...testParameterValue,
            captureImageEvery: +value,
          });
        }}
        minValueInclusive={0}
        style={{ margin: "0px", height: 48 }}
      />

      <ToolsContentTextCheckBox
        disabled={isDisabled}
        id="saveImageEvery"
        checked={testParameterActive.saveCapturedImageEvery}
        label="Save Image Every"
        checkBoxColorVariant={"alternate"}
        value={testParameterValue.saveCapturedImageEvery}
        onClickRadio={() =>
          setTestParameterActive({
            ...testParameterActive,
            saveCapturedImageEvery: !testParameterActive.saveCapturedImageEvery,
          })
        }
        onChangeValue={(value) => {
          setTestParameterValue({
            ...testParameterValue,
            saveCapturedImageEvery: +value,
          });
        }}
        minValueInclusive={0}
        style={{ margin: "0px", height: 48 }}
      />

      <div className={"testing-button-group"}>
        <ToolsContentButton
          text="Stop"
          onClick={stopTest}
          disabled={!isRunningObjectiveSwitchingTest}
          variant="primary"
          colorVariant="black"
        />
        <ToolsContentButton
          text="run"
          onClick={runTest}
          disabled={isDisabled}
          variant="primary"
          colorVariant="default"
        />
      </div>

      <div
        className={"testing-status-box"}
        style={{
          opacity: isDisabled ? 0.5 : 1,
        }}
      >
        <p>{status}</p>
      </div>
    </div>
  );
}
